<template>
  <v-dialog :value="dialog" @click:outside="$emit('updateDialog', false)" max-width="500px">
    <v-card>
      <v-form v-on:submit.prevent="createItem">
        <v-card-title>
          <span class="headline">{{ modal_title }}</span>
        </v-card-title>

        <v-card-text>
          <div class="row">
            <div class="col-md-12">
              <v-text-field data-vv-as="nombre" label="Nombre*" name="name" v-model="item.name" v-validate="'required'"></v-text-field>
              <span class="red--text">{{ errors.first("name") }}</span>
            </div>
            <div class="col-md-12">
              <v-switch v-model="item.enabled" label="Habilitado" color="green"></v-switch>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
          <v-btn color="success" text type="submit" :loading="loading">Guardar</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";

export default {
  mixins: [ModalGenericMixin],
  props: {
    modal_title: String,
    dialog: Boolean,
    item: Object,
  },
  watch: {
    dialog() {
      this.errors.clear();
    },
  },
  methods: {
    createItem(e) {
      if (this.loading) return;
      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();
          const data = { id: this.item.id, name: this.item.name, enabled: this.item.enabled };
          this.loading = true;

          const call = this.item.id > 0
            ? generalService.update(data, Constant.SECTION_COSTS_CENTERS)
            : generalService.create(data, Constant.SECTION_COSTS_CENTERS);

          call
            .then((response) => {
              if (response.status) {
                this.$toast.success("Centro de costo " + (this.item.id > 0 ? "modificado" : "creado") + " correctamente.", "OK");
                this.$emit("updateDialog", false);
                this.$emit("loadList");
              } else {
                this.$toast.error(response.msg, "Error");
              }
            })
            .catch(() => this.$toast.error("Error al guardar.", "Error"))
            .finally(() => (this.loading = false));
        }
      });
    },
  },
};
</script>
